import React, {useState} from "react"
import {useDispatch, useStore} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import VirtualSelect from "../components/VirtualSelect"

export default function SelectBaseDate({id = null}) {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {mainBaseDate, perspective, dateIds, baseDateList},
  } = useStore()

  const [key, setKey] = useState(false)
  const handleChange = (value) => {
    if (!value && id === dateIds[perspective]) {
      mainBaseDate[perspective].key = null
      mainBaseDate[perspective].label = ``
      dispatch({
        type: `SET_MAIN_BASE_DATE`,
        mainBaseDate,
      })
      setKey(!key)
      return
    }
    if (!value) return
    mainBaseDate[perspective].key = value.key
    mainBaseDate[perspective].label = value.label
    dispatch({
      type: `SET_MAIN_BASE_DATE`,
      mainBaseDate,
    })
    dispatch({
      type: `Z_INDEX`,
      zIndex: `baseDate`,
    })
  }

  return (
    <VirtualSelect
      id={id}
      key={key} // necessary to update textField
      required={true}
      target={`baseDate`}
      inputLabel={t(`baseDate`)}
      label={`label`}
      options={baseDateList}
      onChange={handleChange}
      value={mainBaseDate[perspective]}
    />
  )
}
